import { useEffect, useReducer } from "react";

// ---------------------------------------------------------------------------
// Module-level open-state store — lets the nav search field, HELP entry, and
// future Ledger chips summon the palette without prop-drilling through nav.js.
// (02 §2.2: "a tiny module-level event".)
// ---------------------------------------------------------------------------
export const paletteStore = { open: false, mode: "browse", listeners: new Set() };

/** Summon the palette. mode: "browse" (default) | "guide". */
export function openPalette(mode = "browse") {
  paletteStore.open = true;
  paletteStore.mode = mode;
  paletteStore.listeners.forEach((l) => l());
}

export function closePaletteStore() {
  if (!paletteStore.open) return;
  paletteStore.open = false;
  paletteStore.listeners.forEach((l) => l());
}

/** Subscribe to palette open state. */
export function usePaletteOpen() {
  const [, force] = useReducer((n) => n + 1, 0);
  useEffect(() => {
    paletteStore.listeners.add(force);
    return () => paletteStore.listeners.delete(force);
  }, []);
  return { open: paletteStore.open, mode: paletteStore.mode };
}
